import React, {useState} from 'react';
import clsx from 'clsx';
import {makeStyles} from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {SideBar} from './SideBar/SideBar';
import {Outlet} from 'react-router-dom';
import ProtectedHeader from './Header/ProtectedHeader';
import Box from '@mui/material/Box';

const useStyles = makeStyles(({
  root: {
    padding: '9px 0 30px 0',
    backgroundColor: '#F5F8F7',
    height: '100%',
    minHeight: '100vh'
  },
  shiftContent: {
    paddingLeft: 240,
    paddingRight: 0,
    backgroundColor: '#E9EFFB',
  },
  content: {
    marginTop: 0,
    marginRight: 0,
    marginBottom: 15,
    marginLeft: 0,
  },
}));

export const ProtectedMain = props => {
  const {children} = props;
  const classes = useStyles();
  const isDesktop = useMediaQuery('(min-width:1024px)', {
    defaultMatches: true,
  });
  const [openSidebar, setOpenSidebar] = useState(false);
  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop,
      })}
    >
      {/* <ProtectedHeader onSidebarOpen={handleSidebarOpen}/> */}
      <SideBar
        children={children}
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'permanent' : 'temporary'}
      />
      <main className={classes.content}>
        <Outlet/>
      </main>
    </div>
  );
};
